const ReferAFriendIcon2 = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.923 15.111H10.7582C9.77638 15.111 8.98047 14.315 8.98047 13.3332C8.98047 12.3514 9.77638 11.5554 10.7582 11.5554H15.1107M15.1107 11.5554L13.6394 10.085M15.1107 11.5554L13.7774 12.8888"
      stroke="#374151"
      strokeLinecap="round"
    />
    <path
      d="M7.26509 15.1111H3.93496C2.32235 15.1111 1.08125 13.6672 1.76353 12.2061C2.79718 9.99247 4.7961 7.74609 8.24593 7.74609C9.8153 7.74609 11.3519 8.59265 11.9241 9.01593"
      stroke="#374151"
      strokeLinecap="round"
    />
    <path
      d="M11.2329 4.44436C11.2329 6.17741 9.88029 7.55547 8.24437 7.55547C6.60843 7.55547 5.25586 6.17741 5.25586 4.44436C5.25586 2.71131 6.60843 1.33325 8.24437 1.33325C9.88029 1.33325 11.2329 2.71131 11.2329 4.44436Z"
      stroke="#374151"
    />
  </svg>
);

export default ReferAFriendIcon2;
